import request from '@/utils/request'

export default {
  routerNames () {
    return request({
      url: '/routernames'
    })
  },
  industries () {
    return request({
      // cancelToken: cancelToken.token,
      url: `/industries`,
      method: 'get'
    }).catch(err => {
      console.debug('CATCH', err)
    })
  },
  industry (id) {
    return request({
      // cancelToken: cancelToken.token,
      url: `/industries/${id}`,
      method: 'get'
    }).catch(err => {
      console.debug('CATCH', err)
    })
  },
  features () {
    return request({
      // cancelToken: cancelToken.token,
      url: `/features`,
      method: 'get'
    }).catch(err => {
      console.debug('CATCH', err)
    })
  },
  news () {
    return request({
      // cancelToken: cancelToken.token,
      url: `/news/`,
      method: 'get'
    }).catch(err => {
      console.debug('CATCH', err)
    })
  },
  solutions () {
    return request({
      // cancelToken: cancelToken.token,
      url: `/solutions/`,
      method: 'get'
    }).catch(err => {
      console.debug('CATCH', err)
    })
  },
  hotels () {
    return request({
      // cancelToken: cancelToken.token,
      url: `/hotels`,
      method: 'get',
      params: {
        _limit: -1
      }
    }).catch(err => {
      console.debug('CATCH', err)
    })
  },
  partners () {
    return request({
      // cancelToken: cancelToken.token,
      url: `/partners`,
      method: 'get'
    }).catch(err => {
      console.debug('CATCH', err)
    })
  },
  videos () {
    return request({
      // cancelToken: cancelToken.token,
      url: `/videos`,
      method: 'get'
    }).catch(err => {
      console.debug('CATCH', err)
    })
  },
  postContactForm (data) {
    return request({
      url: `/forms`,
      method: 'post',
      data: data
    })
  }
}
